import { render } from "./KalenderPeriod.vue?vue&type=template&id=5379fbfc"
import script from "./KalenderPeriod.vue?vue&type=script&lang=js"
export * from "./KalenderPeriod.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__